var _excluded = ["typography", "emphasis", "color", "align", "isBold", "pushSpace", "hasNoPushReset", "hasLineThrough", "hasNonBreakingSpace", "hasMinWidthFitContent", "hasFitLineHeight", "htmlTag", "hasInheritedColor", "dataTestId", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import TypographyContext from "../../../contexts/TypographyContext";
import { defaultProps } from "./TextAtm.props";
import { StyledTextAtm } from "./TextAtm.styled";
function TextAtm(_ref) {
  var typography = _ref.typography,
    _ref$emphasis = _ref.emphasis,
    emphasis = _ref$emphasis === void 0 ? defaultProps.emphasis : _ref$emphasis,
    color = _ref.color,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? defaultProps.align : _ref$align,
    isBold = _ref.isBold,
    pushSpace = _ref.pushSpace,
    hasNoPushReset = _ref.hasNoPushReset,
    hasLineThrough = _ref.hasLineThrough,
    hasNonBreakingSpace = _ref.hasNonBreakingSpace,
    hasMinWidthFitContent = _ref.hasMinWidthFitContent,
    hasFitLineHeight = _ref.hasFitLineHeight,
    _ref$htmlTag = _ref.htmlTag,
    htmlTag = _ref$htmlTag === void 0 ? defaultProps.htmlTag : _ref$htmlTag,
    hasInheritedColor = _ref.hasInheritedColor,
    dataTestId = _ref.dataTestId,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var inheritedTypography = useContext(TypographyContext);
  var hasInheritedColorCondition = hasInheritedColor || !!inheritedTypography && !emphasis && !color;
  var hasInheritedTypography = !typography && !!inheritedTypography;
  var htmlTagValue = htmlTag;
  if (inheritedTypography) {
    if (isBold) {
      htmlTagValue = "strong";
    } else {
      htmlTagValue = "span";
    }
  }
  return /*#__PURE__*/React.createElement(StyledTextAtm, _extends({
    as: htmlTagValue,
    $typography: typography !== null && typography !== void 0 ? typography : inheritedTypography,
    $onColor: onColor,
    $emphasis: emphasis,
    $color: color,
    $align: align,
    $isBold: !!isBold,
    $pushSpace: pushSpace,
    $hasNoPushReset: !!hasNoPushReset,
    $hasLineThrough: !!hasLineThrough,
    $hasNonBreakingSpace: !!hasNonBreakingSpace,
    $hasMinWidthFitContent: !!hasMinWidthFitContent,
    $hasFitLineHeight: !!hasFitLineHeight,
    $hasInheritedTypography: hasInheritedTypography,
    $hasInheritedColor: hasInheritedColorCondition,
    "data-test-id": dataTestId
  }, restProps), /*#__PURE__*/React.createElement(TypographyContext.Provider, {
    value: typography
  }, hasLineThrough ? /*#__PURE__*/React.createElement("s", null, children) : children));
}
export default TextAtm;